// import stringToHTML helper functions
import { stringToHTML } from '../../../scripts/stringToHTML.js';

// import section style
import './style.scss';

// import template
const _template = require('./tmpl.html?template').default,
  _template_content = stringToHTML(_template).firstChild;

// Add section to body
document.body.append(_template_content);
